import { useQuery } from '@tanstack/react-query';

import { fetchPatientPriorAuths } from '../api/priorAuthApi';
import { priorAuthKeys } from './keys';

export function patientPriorAuthsQueryDefinition(patientUserId: string) {
  return {
    queryKey: priorAuthKeys.patientList(patientUserId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPatientPriorAuths(patientUserId, signal),
    meta: {
      toast: {
        title: 'Could not load prior authorizations',
        description: 'Prior authorization cases could not be fetched.',
      },
    },
  } as const;
}

export function usePatientPriorAuthsQuery(patientUserId: string | undefined) {
  return useQuery({
    ...patientPriorAuthsQueryDefinition(patientUserId ?? ''),
    enabled: !!patientUserId,
  });
}
